import { render } from "./RiskRatedReportWidget.vue?vue&type=template&id=1821b98e"
import script from "./RiskRatedReportWidget.vue?vue&type=script&lang=js"
export * from "./RiskRatedReportWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__